import { CantidadTabletasPOSResturante } from "./constants";

export function descomponerTabletas(total) {
    const parseado = parseInt(total, 10);
    let restante = Number.isNaN(parseado) ? 0 : Math.max(0, parseado);
    const planesDesc = [...CantidadTabletasPOSResturante].sort((a, b) => b.cantidad - a.cantidad);
    const lineas = [];
    for (const plan of planesDesc) {
        const veces = Math.floor(restante / plan.cantidad);
        if (veces > 0) {
            lineas.push({ name: plan.name, cantidad: plan.cantidad, precio: plan.precio, veces });
            restante -= veces * plan.cantidad;
        }
    }
    return lineas;
}

export function precioTabletas(total) {
    return descomponerTabletas(total).reduce((suma, linea) => suma + linea.precio * linea.veces, 0);
}